import React, { useEffect } from "react";

import { YaMapApiLoader } from "../utils";

export default function OrderAdressMap({ location }) {
  let ymaps = null;

  async function mapLoader() {
    ymaps = await YaMapApiLoader();
    const addressMap = new ymaps.Map("map", {
      center: location.coordinates,
      zoom: 15,
      controls: [],
    });

    const homeMarker = new ymaps.Placemark(location.coordinates, null, {
      draggable: true,
    });

    addressMap.geoObjects.add(homeMarker);
  }

  useEffect(() => {
    mapLoader();
  }, []);

  return (
    <div id="map" style={{ width: "100%", height: 600 }} />
  );
}
